import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=f540f0c8&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f540f0c8",
  null
  
)

export default component.exports